<template>
<div>
    <div class="shopcard mb-2 desktop">
        <div class="row">
            <b-col cols="4" class="img-sd" v-bind:style='{ backgroundImage: "url(" + imgUrl + ")", }'>
            </b-col>
            <b-col cols="8">
                <b-card-body>
                    <div class="font14 title mt-3">
                        <router-link :to="{ name: details_route_name, params: {id: routeId} }">
                            {{listName}}
                        </router-link>
                    </div>
                    <p class="font12" v-if="locationStatus">
                        <b-icon style="color:#F7B131" font-scale="1" icon="geo"></b-icon> {{locationStatus}}
                    </p>
                    <p class="font12">
                        <b-icon style="color:#F7B131" font-scale="1" icon="cash"></b-icon> {{currency ? currency: ''}} {{amount? amount: 'Free'}}
                    </p>
                    <p class="font10" v-if="listDesc">
                        {{listDesc | truncate(250)}}
                    </p>
                    <p class="sp-tag"><span><strong>Request date </strong> : {{dateTime | moment("MM/DD/YYYY")}} <small v-if="hostName"> <strong> &nbsp;&nbsp; By</strong> @ {{hostName}}</small>
                        </span>
                        <b-icon class="ml-2 culture-primary" shift-v="-2" v-if="message" @click="handleMessage" font-scale="1" icon="envelope"></b-icon>

                    </p>
                    <p class="fw-bold">Status</p>
                    <div class="card-foot">
                        <a :class="status =='pending'?'btn-warning': status == 'approved'?'badge-success': status == 'available'?'badge-success': status == 'rejectef'?'badge-danger':'badge-danger' " class="font10 pt-2 float-left badge">{{status =='pending'?'Pending': status == 'available'?'Available': status == 'approved'?'Approved': status == 'rejected'?'Rejected':'Cancelled'}}
                        </a>
                        <router-link v-if="needPayment == 'yes' && status !== 'approved'" :to="{ name: torouteName, params: {id: bookingId, type: type, amount: amount, currency: currency} }" class="btn btn-secondary">Pay</router-link>
                        <span v-if="status !== 'cancelled' && status !== 'rejected'" @click="handleCancel" class="float-right">
                            <b-icon font-scale="1" icon="x"></b-icon> Cancel
                        </span>
                    </div>
                </b-card-body>
            </b-col>
        </div>

    </div>
    <div class="shopcard mb-2 mobile">
        <div class="row">
            <b-col cols="4" class="img-sd" v-bind:style='{ backgroundImage: "url(" + imgUrl + ")", }'>
            </b-col>
            <b-col cols="8">
                <div class="font14 mt-3">
                    <router-link :to="{ name: details_route_name, params: {id: routeId} }">
                        {{listName}}
                    </router-link>
                </div>
                <p class="font12" v-if="locationStatus">
                    <b-icon style="color:#F7B131" font-scale="1" icon="geo"></b-icon> {{locationStatus}}
                </p>
                <p class="font12">
                    <b-icon style="color:#F7B131" font-scale="1" icon="cash"></b-icon> {{currency ? currency: ''}} {{amount? amount: 'Free'}}
                </p>
                <p class="font10" v-if="listDesc">
                    {{listDesc | truncate(200)}}
                </p>
                <div class="sp-tag "><span><strong>Request date </strong> : {{dateTime | moment("MM/DD/YYYY")}} </span></div>
                <p class="sp-tag" v-if="hostName"><span><strong>By </strong> @ {{hostName}}
                        <b-icon class="culture-primary" v-if="message" @click="handleMessage" font-scale="1" icon="envelope"></b-icon>

                    </span></p>
            </b-col>
        </div>
        <div class="row mt-3 mb-3 pl-3 pr-2">
            <div class="card-foot">
                <span v-if="cancelBtn" @click="handleCancel" class=" mt-2">
                    <b-icon font-scale="1" icon="x"></b-icon> Cancel
                </span>
                <a :class="status =='pending'?'btn-warning': status == 'approved'?'badge-success': status == 'available'?'badge-success': status == 'rejectef'?'badge-danger':'badge-danger' " class="font10 pt-2 float-left badge">{{status =='pending'?'Pending': status == 'available'?'Available': status == 'approved'?'Approved': status == 'rejected'?'Rejected':'Cancelled'}}
                </a>

            </div>
        </div>

    </div>
</div>
</template>

<script>
export default {
    name: 'listing-card',
    props: ['imgUrl', 'listName', 'cancelBtn', 'locationStatus', 'message', 'details_route_name', 'torouteName', 'routeId', 'bookingId', 'type','listDesc', 'needPayment', 'dateTime', 'hostName', 'status', 'amount', 'currency'],
    methods: {
        handleCancel() {
            this.$emit('handleCancel')
        },
        handleMessage() {
            this.$emit('handleMessage')
        }
    }
}
</script>

<style lang="scss" scoped>
.card-foot {
    display: flex;
    justify-content: space-between;

}

.title a {
    color: #212529 !important;
}

.row {
    margin-left: 0 !important;
}

.card-foot span {
    cursor: pointer;
}

.card-img-top {
    border-radius: 16px 16px 0px 0px;
}

.shopcard {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12) !important;
    border-radius: 16px !important;
    border: none !important;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 265px
    }
}

.shopcard .img-sd {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

}

.card-title {
    font-size: 14px !important;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.2rem !important;

}

.card-img-left {
    width: 31%;
}

.card-title span:nth-child(2) {
    font-size: 10px !important;
    padding: 3px 13px;
    background: rgba(247, 177, 49, 0.15);
    border-radius: 16px;
}

.card-text {
    font-size: 12px !important
}

.card-subtitle {
    font-weight: 900;
    font-size: 14px;
    line-height: 30px;
    letter-spacing: 0.15px;
    color: #F7B131 !important;
    margin-top: 20px
}

.form-control {
    padding: 0.375rem 0rem !important;
}

.card-img-top {
    border-radius: 16px 16px 0px 0px;
}

.sp-tag span {
    font-size: 10px;
    background: rgba(247, 177, 49, 0.15);
    border-radius: 16px;
    padding: 2px 13px 2px 8px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        font-size: 9px;
    }
}

.sp-tag svg {
    cursor: pointer !important;
}
</style>
